import React from 'react';
import { Link } from 'react-router-dom';

const SidebarContent = () => {
  return (
    <div id="sidebar-menu">
      <ul className="metismenu list-unstyled" id="side-menu">
        <li className="menu-title">Audit Menu</li>

        <li>
          <Link to="/dashboard" className="waves-effect">
            <i className="mdi mdi-home"></i>
            <span>Home</span>
          </Link>
        </li>

        <li>
          <Link to="/new-photos" className="waves-effect">
            <i className="mdi mdi-image-multiple"></i>
            <span>Unaudited Photos</span>
          </Link>
        </li>

        <li>
          <Link to="/labeled-photos" className="waves-effect">
            <i className="mdi mdi-label-outline"></i>
            <span>Audited Photos</span>
          </Link>
        </li>

        <li>
          <Link to="/alert-photos" className="waves-effect">
            <i className="mdi mdi-alert-circle-outline"></i>
            <span>Alert Photos</span>
          </Link>
        </li>

        {/* NEW – Export link */}
        <li>
          <Link to="/export-dataset" className="waves-effect">
            <i className="mdi mdi-database-export"></i>
            <span>Export Dataset</span>
          </Link>
        </li>

        <li>
          <Link to="/counters" className="waves-effect">
            <i className="mdi mdi-chart-bar"></i>
            <span>Data Counters</span>
          </Link>
        </li>

        <li className="menu-title">Upload Menu</li>

        <li>
          <Link to="/upload-photo" className="waves-effect">
            <i className="mdi mdi-upload"></i>
            <span>Upload Photos</span>
          </Link>
        </li>

        <li>
          <Link to="/logout" className="waves-effect">
            <i className="mdi mdi-power"></i>
            <span>Logout</span>
          </Link>
        </li>
      </ul>
    </div>
  );
};

export default SidebarContent;

